// extracted by mini-css-extract-plugin
export default {"svgIcon":"rlSin65i"};